/* eslint-disable @typescript-eslint/no-explicit-any */
import { makeStyles, tokens } from '@fluentui/react-components';
import { ReactNode } from 'react';

interface ComponentToMountProps {
  key?: number | string;
  label: string;
  children?: ReactNode;
	tabrow?: number;
}


const ComponentToMount = (props: ComponentToMountProps) => {
	const classes = useStyles();

	return (
		<div className={classes.row} style={{ paddingLeft: props.tabrow ? props.tabrow * 24 : 0 }}>
			<span className={classes.label}>
				{props.label}
			</span>
			{' '}
			<span className={classes.value}>
				{props?.children}
			</span>
		</div>
	);
};

export function parseJsonData (data: string) {
	const componentsToRender: Array<{
    node: (props: any) => ReactNode
  }> = [];
  
	const mountNodes = (obj: Record<string | number | symbol, any>, levelNumber = 0) => {
		Object
			.keys(obj)
			.forEach((key) => {
				const value = obj[key];
				const valueIsObj = typeof value === 'object';

				if (valueIsObj) {
					componentsToRender.push({
						node: ({ children }) => (
							<ComponentToMount tabrow={levelNumber} label={key}>
								{children}
							</ComponentToMount>
						) 
					});

					mountNodes(value, levelNumber + 1);
				}

				if (!valueIsObj) {
					componentsToRender.push({
						node: () => (
							<ComponentToMount tabrow={levelNumber} label={key}>
								{value}
							</ComponentToMount>
						) 
					});

				}
			});
	};

	const parsedObj = JSON.parse(data);
	mountNodes(parsedObj);
  
	return componentsToRender.map((item, idx) => {
		const Component = item.node;
		return <Component key={idx} />;
	});
}

const useStyles = makeStyles({
	row: {
		padding: '4px 0px'
	},
	label: {
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase300,
		fontWeight: tokens.fontWeightBold,
		lineHeight: tokens.lineHeightBase200,
		marginRight: '8px'
	},
	value: {
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase300,
		fontWeight: tokens.fontWeightRegular,
		lineHeight: tokens.lineHeightBase200,
		marginRight: '8px'
	}
});